import { indexReducedPattern } from "../constants";

export function buildRoyaltiesQuery({ accounts, writers, songs, dateFrom, dateTo, dateType, showHistoric }) {
  const fromStr = dateFrom.toISOString().split("T", 1)[0];
  const toStr = dateTo.toISOString().split("T", 1)[0];

  const filters = [
    { range: { [dateType]: { format: "strict_date_optional_time", gte: fromStr, lte: toStr } } },
    { terms: { artistAccountCode: accounts } },
    { term: { rowHidden: false } },
  ];

  if (writers?.length) {
    filters.push({ terms: { writerCode: writers } });
  }

  if (songs?.length) {
    filters.push({ terms: { songCode: songs } });
  }

  if (!showHistoric) {
    filters.push({
      bool: {
        must_not: {
          term: { distributionUniqueCode: "HISTORIC" },
        },
      },
    });
  }

  return {
    index: indexReducedPattern,
    body: {
      query: {
        bool: { filter: filters },
      },
      aggs: {
        SongCount: { cardinality: { field: "songCode" } },
        Songs: {
          terms: { field: "songCode", size: 500, order: { SongValues: "desc" }, missing: "N/A" },
          aggs: {
            SongValues: { sum: { field: "ownerWriterPayment" } },
            SongTitle: { terms: { field: "songTitle.keyword", size: 1 } },
            ArtistAccountCode: { terms: { field: "artistAccountCode", size: 1 } },
          },
        },
        WriterPaymentSum: { sum: { field: "ownerWriterPayment" } },
        Writers: {
          terms: { field: "writerCode", size: 500, order: { WriterValues: "desc" }, missing: "N/A" },
          aggs: {
            WriterValues: { sum: { field: "ownerWriterPayment" } },
            WriterName: {
              top_hits: {
                size: 1,
                _source: { includes: ["writerLastName", "writerFirstName", "writerMiddleName"] },
              },
            },
          },
        },
        ArtistAccounts: {
          terms: { field: "artistAccountCode", size: 1, order: { WriterValues: "desc" }, missing: "N/A" },
          aggs: {
            WriterValues: { sum: { field: "ownerWriterPayment" } },
            ArtistAccountName: {
              top_hits: { size: 1, _source: { includes: ["artistAccountName"] } },
            },
          },
        },
        Territories: {
          terms: { field: "territoryName.keyword", size: 500, order: { WriterValues: "desc" }, missing: "N/A" },
          aggs: { WriterValues: { sum: { field: "ownerWriterPayment" } } },
        },
        IncomeTypes: {
          terms: { field: "incomeType.keyword", size: 500, order: { WriterValues: "desc" }, missing: "N/A" },
          aggs: { WriterValues: { sum: { field: "ownerWriterPayment" } } },
        },
        UsageTypes: {
          terms: { field: "usage.keyword", size: 500, order: { WriterValues: "desc" }, missing: "N/A" },
          aggs: { WriterValues: { sum: { field: "ownerWriterPayment" } } },
        },
        CumulativeSumHistogram: {
          date_histogram: {
            field: dateType,
            calendar_interval: "1M",
            time_zone: "Europe/London",
            min_doc_count: 0,
            extended_bounds: {
              min: fromStr,
              max: toStr,
            },
          },
          aggs: {
            CumulativeSumPipeline: { cumulative_sum: { buckets_path: "CumulativeSum" } },
            CumulativeSum: { sum: { field: "ownerWriterPayment" } },
          },
        },
      },
      size: 0,
    },
  };
}
